export const fixOverlayScroll = (state: boolean) => {
  const body = document.documentElement
  body.style.maxHeight = state ? '100%' : ''
  body.style.overflow = state ? 'hidden' : ''
  body.style.width = state ? '100%' : ''
}
